import { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { getTournamentPlayers } from '../../services/tournament.service';

const headerSx = {
  background: '#565656',
  color: '#e2e8f0',
  fontWeight: 700,
  letterSpacing: 0.5,
};

const cellSx = {
  background: '#9295a9',
  color: '#1a1f2e',
  fontWeight: 500,
  borderBottom: '1px solid rgba(0,0,0,0.15)',
};

const TournamentPlayers = ({ torId }) => {
  const [players, setPlayers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchPlayers = async () => {
      setIsLoading(true);
      try {
        const data = await getTournamentPlayers(torId);
        setPlayers(data);
      } catch (e) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlayers();
  }, [torId]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress sx={{ color: '#7c8cf8' }} />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error" sx={{ py: 3 }}>
        Error al cargar los jugadores.
      </Typography>
    );
  }

  if (!players.length) {
    return (
      <Typography sx={{ color: '#9aa5b4', py: 3 }}>
        No hay jugadores inscriptos en este torneo.
      </Typography>
    );
  }

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: 0,
        border: '1px solid rgba(255,255,255,0.08)',
        background: 'transparent',
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...headerSx, width: 70 }}>Pos.</TableCell>
            <TableCell sx={headerSx}>Apellido y Nombre</TableCell>
            <TableCell sx={{ ...headerSx, width: 100, textAlign: 'center' }}>Puntaje</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {players.map((p, idx) => (
            <TableRow key={idx} hover>
              <TableCell sx={{ ...cellSx, fontWeight: 700, textAlign: 'center' }}>
                {p.jpt_posicion_final ?? '—'}
              </TableCell>
              <TableCell sx={cellSx}>{p.apellido_nombre}</TableCell>
              <TableCell sx={{ ...cellSx, textAlign: 'center' }}>
                {p.jpt_puntaje_final ?? '—'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TournamentPlayers;
